<template>
    <v-card class="investment-overview elevation-2">
        <v-card-title class="primary--text">
            <v-icon left color="primary">mdi-chart-pie</v-icon>
            Tabuľka koeficientov
        </v-card-title>

        <v-card-text>
            <!-- Informácia č.1: Úrovne investícií -->
            <v-row>
                <v-col cols="12">
                    <v-card outlined>
                        <!-- <v-card-subtitle>
                            <v-icon left small>mdi-information</v-icon>
                            Informácia č.1: Koľko treba vrátiť investorom v prípade celej výšky prijatej investície
                        </v-card-subtitle> -->
                        <v-card-text>
                            <v-data-table :headers="investmentLevelsHeaders" :items="enrichedInvestmentLevels"
                                hide-default-footer class="elevation-1" :items-per-page="-1">
                                <template v-slot:item.level="{ item }">
                                    <v-chip small color="primary" outlined>
                                        Úroveň {{ getInvestmentLevelNumber(item.threshold) }}
                                    </v-chip>
                                </template>

                                <template v-slot:item.level_range="{ item }">
                                    {{ formatCurrency(item.range_start) }} - {{ formatCurrency(item.threshold) }}
                                </template>

                                <template v-slot:item.investment_amount="{ item }">
                                    <strong>{{ formatCurrency(item.investment_amount) }}</strong>
                                </template>

                                <template v-slot:item.coefficient="{ item }">
                                    <v-chip small :color="getCoefficientColor(item.coefficient)">
                                        {{ item.coefficient }}x
                                    </v-chip>
                                </template>

                                <template v-slot:item.total_payout="{ item }">
                                    <span class="success--text font-weight-bold">
                                        {{ formatCurrency(item.total_payout) }}
                                    </span>
                                </template>

                                <template v-slot:item.progress="{ item }">
                                    <div style="min-width: 120px;">
                                        <v-progress-linear :value="getProgressPercentage(item)"
                                            :color="getProgressColor(item)" height="20" rounded>
                                            <span class="white--text caption">
                                                {{ getProgressPercentage(item).toFixed(1) }}%
                                            </span>
                                        </v-progress-linear>
                                    </div>
                                </template>
                            </v-data-table>

                            <v-divider class="my-4"></v-divider>

                            <v-row>
                                <!-- <v-col cols="12" sm="6" md="3">
                                    <v-card outlined color="warning lighten-4">
                                        <v-card-text class="text-center">
                                            <div class="text-caption">Celkovo s možným benefitom</div>
                                            <div class="text-h5 warning--text">
                                                {{ formatCurrency(totalPayoutRequired) }}
                                            </div>
                                            <div class="text-caption grey--text">Pri maximálnej sume darov</div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-card outlined color="info lighten-4">
                                        <v-card-text class="text-center">
                                            <div class="text-caption">Aktuálne darované</div>
                                            <div class="text-h5 info--text">
                                                {{ formatCurrency(totalInvestments) }}
                                            </div>
                                            <div class="text-caption grey--text">Všetci darcovia</div>
                                        </v-card-text>
                                    </v-card>
                                </v-col> -->
                                <!-- <v-col cols="12" sm="6" md="3">
                                    <v-card outlined color="success lighten-4">
                                        <v-card-text class="text-center">
                                            <div class="text-caption">Aktuálny nárok investorov</div>
                                            <div class="text-h5 success--text">
                                                {{ formatCurrency(currentPayoutClaim) }}
                                            </div>
                                            <div class="text-caption grey--text">Podľa aktuálnych investícií</div>
                                        </v-card-text>
                                    </v-card>
                                </v-col> -->
                                <!-- <v-col cols="12" sm="6" md="3">
                                    <v-card outlined color="error lighten-4">
                                        <v-card-text class="text-center">
                                            <div class="text-caption">Skutočne vyplatené</div>
                                            <div class="text-h5 error--text">
                                                {{ formatCurrency(actualPayouts) }}
                                            </div>
                                            <div class="text-caption grey--text">Doteraz vyplatené darcom</div>
                                        </v-card-text>
                                    </v-card>
                                </v-col> -->
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Informácia č.2: Aktuálny stav investícií -->
            <v-row class="mt-4">
                <v-col cols="12">
                    <v-card outlined>
                        <!-- <v-card-subtitle>
                            <v-icon left small>mdi-information</v-icon>
                            Informácia č.2: Aktuálna výška investícií a prislúchajúci benefit
                        </v-card-subtitle> -->
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <!-- Progress chart pre investície -->
                                    <div class="text-center mb-4">
                                        <div class="text-h6 mb-2">Pokrok k maximálnej výške daru</div>
                                        <v-progress-circular :value="investmentProgress" :size="120" :width="15"
                                            color="primary">
                                            <span class="text-h6">{{ investmentProgress.toFixed(1) }}%</span>
                                        </v-progress-circular>
                                    </div>

                                    <v-list dense>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Aktuálna výška darov</v-list-item-title>
                                                <v-list-item-subtitle>{{ formatCurrency(totalInvestments)
                                                    }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Maximálna plánovaná suma darov</v-list-item-title>
                                                <v-list-item-subtitle>{{ formatCurrency(maxInvestmentAmount)
                                                    }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Zostáva do maxima</v-list-item-title>
                                                <v-list-item-subtitle class="primary--text">
                                                    {{ formatCurrency(Math.max(0, maxInvestmentAmount -
                                                    totalInvestments)) }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <!-- Štatistiky investorov -->
                                    <div class="text-center mb-4">
                                        <div class="text-h6 mb-2">Štatistiky darcov</div>
                                    </div>

                                    <v-list dense>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Počet uzatvorených zmlúv</v-list-item-title>
                                                <v-list-item-subtitle class="text-h6 info--text">{{ totalContracts
                                                    }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Počet unikátnych darcov</v-list-item-title>
                                                <v-list-item-subtitle class="text-h6 success--text">{{ uniqueInvestors
                                                    }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Priemerná výška daru</v-list-item-title>
                                                <v-list-item-subtitle class="text-h6">{{
                                                    formatCurrency(averageInvestment)
                                                    }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Informácia č.3: Výplaty investorom -->
            <!-- <v-row class="mt-4">
                <v-col cols="12">
                    <v-card outlined>
                        <v-card-subtitle>
                            <v-icon left small>mdi-information</v-icon>
                            Informácia č.3: Skutočne vyplatené investície aj s benefitmi
                        </v-card-subtitle>
                        <v-card-text>
                            <v-alert type="info" outlined class="mb-4">
                                <strong>Celková suma vyplatených investícií všetkým investorom: {{
                                    formatCurrency(actualPayouts)
                                }}</strong>
                            </v-alert>

                            <v-row v-if="payoutHistory.length > 0">
                                <v-col cols="12">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Mesiac</th>
                                                    <th>Suma výplat</th>
                                                    <th>Počet investorov</th>
                                                    <th>Priemerná výplata</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="payout in payoutHistory" :key="payout.month">
                                                    <td>{{ payout.month }}</td>
                                                    <td><strong>{{ formatCurrency(payout.amount) }}</strong></td>
                                                    <td>{{ payout.investorCount }}</td>
                                                    <td>{{ formatCurrency(payout.averagePayout) }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>

                            <v-alert v-else type="warning" outlined>
                                Zatiaľ neboli vykonané žiadne výplaty investorom.
                            </v-alert>

                            <v-row class="mt-4">
                                <v-col cols="12">
                                    <v-alert type="info" outlined>
                                        <div class="font-weight-bold mb-2">Rozdiel medzi {{ formatCurrency(10000000) }}
                                            a skutočnou
                                            investovanou sumou sa vyplatí ihneď</div>
                                        <div class="text-body-2">
                                            Prepočet na vyplácanie sa ilustruje na {{ formatCurrency(10000000) }}
                                            investícií spolu
                                            a teda na zaťaženie {{ formatCurrency(23000000) }}. Ale ak sa investuje len
                                            napríklad
                                            {{ formatCurrency(6500000) }}, tak sa logicky číslo splácania na jeden
                                            podiel zväčší
                                            a bude to vyplácané vo vyššej výške a bude to teda vyplatené skôr.
                                        </div>
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row> -->
        </v-card-text>
    </v-card>
</template>

<script>
import {
    calculateInvestmentBreakdown,
    calculatePayoutClaim,
    formatCurrency
} from '@/utils/investment-math';
import {
    INVESTMENT_LEVEL_TABLE,
    INVESTMENT_CAPACITY,
    TOTAL_PAYOUT_REQUIRED
} from '@/config/investment';

export default {
    name: "InvestmentOverviewTable",

    props: {
        totalContracts: {
            type: Number,
            default: 0
        },
        uniqueInvestors: {
            type: Number,
            default: 0
        },

        totalInvestments: {
            type: Number,
            default: 0
        },
        totalInvestmentLevels: {
            type: Array,
            default: () => INVESTMENT_LEVEL_TABLE.map(l => ({ ...l }))
        },
        totalPayoutRequired: {
            type: Number,
            default: () => TOTAL_PAYOUT_REQUIRED
        },
        actualPayouts: {
            type: Number,
            default: 0
        },
        maxInvestmentAmount: {
            type: Number,
            default: () => INVESTMENT_CAPACITY
        }
    },

    data() {
        return {

            // Z Excel tabuľky "Reálne tržby"
            payoutHistory: [
                { month: 'Január 2025', amount: 171217, investorCount: 45, averagePayout: 3804.82 },
                { month: 'Február 2025', amount: 199753, investorCount: 52, averagePayout: 3841.40 }
            ],

            investmentLevelsHeaders: [
                { text: 'Úroveň', value: 'level', sortable: false, width: '100px' },
                { text: 'Rozsah', value: 'level_range', sortable: false },
                { text: 'Výška daru', value: 'investment_amount', align: 'right' },
                { text: 'Koeficient benefitu', value: 'coefficient', align: 'center' },
                { text: 'Možná výška benefitu', value: 'total_payout', align: 'right' },
                { text: 'Pokrok', value: 'progress', sortable: false, align: 'center', width: '150px' }
            ]
        };
    },

    computed: {
        enrichedInvestmentLevels() {
            return this.totalInvestmentLevels.map((level, index) => ({
                ...level,
                range_start: index === 0 ? 0 : this.totalInvestmentLevels[index - 1].threshold
            }));
        },

        investmentProgress() {
            return (this.totalInvestments / this.maxInvestmentAmount) * 100;
        },

        averageInvestment() {
            return this.totalContracts > 0 ? this.totalInvestments / this.totalContracts : 0;
        },

        // Výpočet aktuálneho nároku podľa komentárov v Excel
        currentPayoutClaim() {
            // Use utility for calculation
            // Note: calculateInvestmentBreakdown expects levels with 'threshold' and 'coefficient'.
            // The logic here previously was calculating claim for the "Total Investments" across all levels.
            // This is effectively calculating the breakdown for the TotalInvestments amount starting from 0.
            const breakdown = calculateInvestmentBreakdown(
                this.totalInvestments,
                0, // Current total is 0 because we are calculating the claim for the ENTIRETY of totalInvestments
                this.totalInvestmentLevels
            );
            return calculatePayoutClaim(breakdown);
        }
    },

    methods: {
        formatCurrency,

        getInvestmentLevelNumber(threshold) {
            const index = this.totalInvestmentLevels.findIndex(l => l.threshold === threshold);
            return index + 1;
        },

        getCoefficientColor(coefficient) {
            if (coefficient >= 5) return 'success';
            if (coefficient >= 4) return 'warning';
            if (coefficient >= 3) return 'orange';
            if (coefficient >= 2) return 'error';
            return 'grey';
        },

        getProgressPercentage(item) {
            const levelStart = item.range_start;
            const levelInvestment = Math.max(0, Math.min(this.totalInvestments - levelStart, item.investment_amount));
            return (levelInvestment / item.investment_amount) * 100;
        },

        getProgressColor(item) {
            const progress = this.getProgressPercentage(item);
            if (progress >= 100) return 'success';
            if (progress >= 75) return 'warning';
            if (progress >= 25) return 'orange';
            return 'error';
        }
    }
};
</script>

<style scoped>
.investment-overview {
    margin-bottom: 24px;
}

.v-progress-circular {
    margin: 1rem;
}

.font-weight-bold {
    font-weight: 600 !important;
}

.v-data-table>>>.v-data-table__wrapper {
    border-radius: 8px;
}

@media (max-width: 600px) {
    .text-h5 {
        font-size: 1.3rem !important;
    }

    .text-h6 {
        font-size: 1.1rem !important;
    }
}
</style>